import React from "react";
import LandingNavbar from "../landing/LandingNavbar";
import Footer from "../landing/Footer";
import { APP_DOMAIN } from '../../core/utils/config';
import { typography, surfaces, brandColors } from "../../design-system/tokens";
import FeedbackForm from "./FeedbackForm";

const Feedback = () => {
  return (
    <div className={`min-h-screen ${surfaces.secondary} flex flex-col`}>
      <LandingNavbar />
      
      <div className="flex-1 pt-16">
        {/* Brand Gradient Header Section */}
        <div className={`bg-gradient-to-r ${brandColors.gradientFrom} ${brandColors.gradientTo} text-white`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="text-center">
              <h1 className={`${typography.h1Dark} mb-4`}>
                Help us improve {APP_DOMAIN} for you!
              </h1>
              <p className={`${typography.bodyLargeDark}`}>
                Give us your suggestions or feedback
              </p>
            </div>
          </div>
        </div>

        {/* Feedback Form Content */}
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <FeedbackForm situation="PUBLIC_FEEDBACK_PAGE" />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Feedback;